<form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
  <mat-form-field hideRequiredMarker>
    <mat-label>Email</mat-label>
    <input type="email" matInput [formControl]="signInForm.controls.email" />
  </mat-form-field>

  <mat-form-field hideRequiredMarker>
    <mat-label>Password</mat-label>
    <mat-icon matSuffix color="primary" (click)="toggleHidePassword()">{{
      hidePassword() ? "visibility_off" : "visibility"
    }}</mat-icon>
    <input
      [type]="hidePassword() ? 'password' : 'text'"
      matInput
      [formControl]="signInForm.controls.password"
    />
  </mat-form-field>

  <button mat-flat-button color="primary" [disabled]="!signInForm.valid">
    {{ buttonText() }}
  </button>
</form>
